import { dossierStageCancelled, permissions } from '../constants/backendIds'

export function validateShowIfContractDocument (props, documentFile) {
  return props.fieldsConfiguration?.importContractBtn?.permission === permissions.editable && !dossierStageCancelled.includes(props.dossierStageId)
}

export function getContractDocument (props, documentFile) {
  props.actions.setContractByDossier(props.dossierId, props.isHistorical ?? false)
}

export default {
  validateShowIfContractDocument,
  getContractDocument
}
